import React from 'react';
import queryString from 'query-string';
import { Button, Form, Progress, Row, Col } from "reactstrap";
import { CSSTransition } from 'react-transition-group';

import { WithLocalize } from '../../containers/I18nProvider';
import { WithCaptcha } from '../../containers/captcha';
import countries from './countries.json';

/**
 * Login Form Container
 *
 * @class LoginForm
 * @extends {React.Component}
 */
class LoginForm extends React.Component {

  constructor(props, context) {
    super(props, context);

    this.parameters = queryString.parse(props.location.search);
    this.parameters.idp = 'gvpprod';
    this.ref = React.createRef();
    this.state = {
      onLogin: false,
      showForm: false,
      error: {
        open: false,
        message: ''
      },
      username: '',
      password: ''
    };
    this.text = props.text;
  }

  componentDidMount() {

    this.setState({ showForm: true });
  }

  onError(error) {
    this.setState({
      error: {
        open: true,
        message: error.message
      }
    });
  }

  async onSubmit(ev) {
    ev.preventDefault();

    this.setState({
      onLogin: true,
      error: {
        open: false,
        message: ''
      }
    });


    const instanceId = this.props.showCountries ? this.countriesSelect.value : this.text.instanceId;

    this.props.api.userPassLogin(
      {
        email: this.emailInput.value,
        password: this.passwordInput.value.replace(/[\u00A0-\u9999<>&]/g, (i) => '&#' + i.charCodeAt(0) + ';'),
        instanceId
      }, this.parameters
    )
      .then((response) => {
        this.setState({ onLogin: false });
        window.location = this.parameters.redirect_uri + '?' + queryString.stringify(response);
      })
      .catch(error => {
        const translate = this.props.translate(error.errorCode);

        let message = 'Occurrió un error.';

        if (translate) {
          message = translate;
        } else if (error.details) {
          message = error.details;
        }

        this.setState({ onLogin: false, error: { open: true, message: message } });
      });
  }

  render() {
    const { translate, showCountries } = this.props;

    return (
      <CSSTransition
        in={this.state.showForm}
        timeout={300}
        classNames="formshow"
        nodeRef={this.ref}
        unmountOnExit
      >
        <div ref={this.ref}>
          <Form onSubmit={event => this.onSubmit(event)}>
            {showCountries ?
              <select
                ref={(ref) => {
                  this.countriesSelect = ref;
                }}
              >
                {
                  countries.map(country => {
                    return <option value={country.instanceId} key={country.code}>{country.label}</option>
                  })
                }
              </select>
              : null}

            <input
              className="form-control user-input"
              disabled={this.state.onLogin}
              placeholder={translate('PlaceholderUserName')}
              ref={(ref) => {
                this.emailInput = ref;
              }
              }
              required={true}
              tabIndex={1}
              type="email"
              autoCorrect="off"
              autoCapitalize="none"
              id="username"
            />
            <input
              className="form-control pass-input"
              required={true}
              disabled={this.state.onLogin}
              placeholder={translate('PlaceholderPassword')}
              ref={(ref) => {
                this.passwordInput = ref;
              }
              }
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              id="password"
            />
            <div className="buttons">
              {!this.state.onLogin ?
                <Button
                  block={!this.parameters.failureRedirect}
                  color="danger"
                  size="lg"
                  tabIndex={1}
                  type="submit"
                  id="submit"
                  disabled={!this.props.turnstileSuccess}
                >
                  {translate('ButtonEnter')}
                </Button> :
                <Progress animated color="danger" value={100} />}
            </div>

            {
              this.text.extras ?
                <Row>
                  <Col className="text-center">
                    {
                      this.text.extras.password ?
                        <a className="links-gvp" href={this.text.extras.password.link} id="reset-password">
                          <p>{this.text.extras.password.text}</p>
                        </a>
                        : null
                    }
                    {
                      this.text.extras.title ?
                        <a className="links-gvp" href={this.text.extras.title.link} id="client-page">
                          {this.text.extras.title.text}
                        </a>
                        : null
                    }
                  </Col>
                </Row>
                : null
            }

            {
              this.state.error.open ?
                <p className="links" id="error-message">{this.state.error.message}</p>
                : null
            }

            <this.props.TurnstileComponent setTurnstileSuccess={this.props.setTurnstileSuccess} />
          </Form>
        </div>
      </CSSTransition>
    );
  }
}

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
